module.exports = __webpack_public_path__ + "files/6f37bbf8bf1801a9f153d703588b471a.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/code_themes/solarized-light.png
// module id = 699
// module chunks = 27